import React, { memo } from "react";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {
  faCar,
  faGem,
  faCouch,
  faFaucet,
  faWrench,
  faShield,
} from "@fortawesome/free-solid-svg-icons";

const industries = [
  {
    id: 1,
    title: "Automotive",
    text: "Premium electroplating treatments for engine parts, trim, and accessories.",
    image: "./assets/engine.jpeg",
    icon: faCar,
  },
  {
    id: 2,
    title: "Jewelry",
    text: "Expert gold, silver, and rhodium plating for exquisite treasures.",
    image: "./assets/accessories.jpeg",
    icon: faGem,
  },
  {
    id: 3,
    title: "Furniture",
    text: "Electroplating solutions for furniture hardware and decorative elements.",
    image: "./assets/furniture.jpeg",
    icon: faCouch,
  },
  {
    id: 4,
    title: "Plumbing",
    text: "Precision chrome plating for faucets, fixtures, and sanitary equipment.",
    image: "./assets/pipes.jpeg",
    icon: faFaucet,
  },
  {
    id: 5,
    title: "Restoration",
    text: "Meticulous electroplating for vintage and antique restoration.",
    image: "./assets/motorcycle.jpeg",
    icon: faWrench,
  },
  {
    id: 6,
    title: "Military",
    text: "Firearm refinishing and military equipment plating with precision.",
    image: "./assets/goldgun.jpeg",
    icon: faShield,
  },
];

const KeyIndustries = () => {
  return (
    <section className="industries-section">
      <Container>
        <div className="section-header">
          <span className="section-label">Who We Serve</span>
          <h2 className="section-title">Industries</h2>
          <p className="section-subtitle">
            We take pride in offering our electroplating and metal finishing expertise
            to a diverse range of industries, delivering outstanding results that enhance
            the performance and aesthetics of their products.
          </p>
        </div>

        <Row xs={1} sm={2} lg={3} className="g-4">
          {industries.map((industry) => (
            <Col key={industry.id}>
              <article className="industry-card-pro">
                <div className="industry-card-pro-image">
                  <img
                    src={industry.image}
                    alt={industry.title}
                    loading="lazy"
                  />
                  <div className="industry-card-pro-overlay" />
                </div>
                <div className="industry-card-pro-content">
                  {/* <div className="industry-card-pro-icon">
                    <FontAwesomeIcon icon={industry.icon} />
                  </div> */}
                  <h3 className="industry-card-pro-title">{industry.title}</h3>
                  <p className="industry-card-pro-text">{industry.text}</p>
                  {/* <span className="industry-card-pro-link">
                    Learn More
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </span> */}
                </div>
              </article>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default memo(KeyIndustries);
